export default {
  email_confirm: {
    header: {
      title: 'Hoàn tất xác nhận địa chỉ email',
    },
    completed: {
      // section_one: '',
      // section_two: '',
      // section_three: '',
      // section_four: '',
    },
    expired: {
      // section_one: '',
      // section_two: '',
      // section_three: '',
    },
    btn: {
      // service_top: '',
      // login: '',
      register: 'Đăng ký',
      rating_url: 'https://asuene.com/rating/en',
    },
  },
}
